import { useSyncExternalStore } from 'react'

const STORAGE_KEY = 'pp_launch_end_v1'
const DURATION_MS = 12 * 60 * 1000

let endTime: number | null = null
let timer: ReturnType<typeof setInterval> | null = null
const listeners = new Set<() => void>()

function resolveEndTime(): number {
  if (endTime !== null) return endTime
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    if (saved && !Number.isNaN(Number(saved))) {
      endTime = Number(saved)
    } else {
      endTime = Date.now() + DURATION_MS
      window.localStorage.setItem(STORAGE_KEY, String(endTime))
    }
  } catch {
    endTime = Date.now() + DURATION_MS
  }
  return endTime
}

function getSecondsLeft(): number {
  return Math.max(0, Math.ceil((resolveEndTime() - Date.now()) / 1000))
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  if (!timer) {
    timer = setInterval(() => {
      listeners.forEach((l) => l())
      if (getSecondsLeft() === 0 && timer) {
        clearInterval(timer)
        timer = null
      }
    }, 1000)
  }
  return () => {
    listeners.delete(listener)
    if (listeners.size === 0 && timer) {
      clearInterval(timer)
      timer = null
    }
  }
}

export function useLaunchCountdown() {
  const secondsLeft = useSyncExternalStore(subscribe, getSecondsLeft, () => 0)
  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60
  return {
    secondsLeft,
    isActive: secondsLeft > 0,
    formatted: `${pad(minutes)}:${pad(seconds)}`,
  }
}

function pad(n: number) {
  return String(n).padStart(2, '0')
}
